import { Fieldset as BaseFieldset } from '@base-ui/react';

import { CheckboxDescription } from './CheckboxDescription';
import { CheckboxGroup } from './CheckboxGroup';
import { CheckboxLabel } from './CheckboxLabel';
import { CheckboxRoot } from './CheckboxRoot';

export const Checkbox = {
  Group: CheckboxGroup,
  GroupLegend: BaseFieldset.Legend,
  Root: CheckboxRoot,
  Label: CheckboxLabel,
  Description: CheckboxDescription,
};
